export default "__VITE_ASSET__D1SI01IJ__"